import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';

const AxiosPortalContext = createContext({
  instance: {}
});
const AxiosMenuContext = createContext({
  instance: {}
});
const AxiosPortalProvider = ({
  instance,
  children
}) => {
  return /* @__PURE__ */ jsx(AxiosPortalContext.Provider, { value: {
    instance
  }, children });
};
const usePortalAxios = () => useContext(AxiosPortalContext);
const AxiosMenuProvider = ({
  instance,
  children
}) => {
  return /* @__PURE__ */ jsx(AxiosMenuContext.Provider, { value: {
    instance
  }, children });
};
const useMenuAxios = () => useContext(AxiosMenuContext);

export { AxiosMenuContext, AxiosMenuProvider, AxiosPortalContext, AxiosPortalProvider, useMenuAxios, usePortalAxios };
